<script>
import simpleLoading from '@/components/simpleLoading';
import hoverDesign from '@/components/hoverDesign';
import movieBg from '@/components/movieBg.vue';
export default {
  name: 'youtubeContainer',
  components: {
    simpleLoading,
    hoverDesign,
    movieBg,
  },
  props: {
    fileUrl: { // 8YLjj253INwみたいな部分のみ
      type: String,
      required: true,
    },
    youtubeWidth: {
      type: Number || String,
      default: 400,
    },
    youtubeHeight: {
      type: Number || String,
      default: 225,
    },
    isCloseBtnWhite: { // 閉じるボタンを白くする
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isShowMovie: false,
    };
  },
  methods: {
    showMovie() {
      this.isShowMovie = !this.isShowMovie;
    },
  }
};
</script>

<template>
  <div class="youtube-container" @click="showMovie">
    <div class="on-load">
      <div class="loading">
        <simple-loading/>
      </div>
    </div>
    <iframe
      :width="youtubeWidth"
      :height="youtubeHeight"
      :src="`https://www.youtube.com/embed/${fileUrl}`"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <hover-design hover-design="playMovie"/>
    
    <div class="movie-bg fixed100" v-if="isShowMovie">
      <movie-bg />
      <div class="movie-container">
        <div class="on-load">
          <div class="loading">
            <simple-loading :dot-radius='20'/>
          </div>
        </div>
        <iframe
          width="100%" height="100%" 
          :src="`https://www.youtube.com/embed/${fileUrl}`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div class="close-movie" :title="$t('message.common.close')" :class="isCloseBtnWhite ? 'is-white' : ''"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .youtube-container {
    position: relative;
    .on-load {
      .loading {
        @include absolute100;
      }
    }
    iframe {
      max-width: 100%!important;
      position: relative;
      display: block;
    }
    .movie-bg {
      z-index: $zIndexMovieContainer;
      display: flex;
      justify-content: center;
      align-items: center;
      .movie-container {
        width: 100%;
        max-width: 1280px;
        aspect-ratio: 16 / 9;
        animation: fadeUpAnime1 1s ease-out 0s 1;
        position: relative;
      }
      iframe {
        display: block;
      }
      .close-movie {
        position: absolute;
        top: 10px;
        right: 10px;
        @include bgCenter;
        background-image: url('../assets/img/common/btnClose_b.svg');
        width: 80px;
        height: 80px;
        cursor: pointer;
        transition: 0.2s ease;
        transform-origin: 50% 50%;
        transform: scale(1) rotate(0deg);
        &:hover {
          transform: scale(1.1) rotate(90deg);
        }
        &.is-white {
          background-image: url('../assets/img/common/btnClose.svg');
        }
      }
    }
  }
</style>
